import type { CSATFeature } from "@/api/generated/models";

export const QUESTION_TYPES = {
  RATING: "rating",
  FREE_TEXT: "freeText",
} as const;

export type QuestionType = (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];

export type AnswerValue = number | string | null;
export type Answers = Record<string, AnswerValue>;

type BaseQuestion = {
  key: string;
  text: string;
  subtitle?: string;
  showIf?: (answers: Answers) => boolean;
};

export type RatingQuestion = BaseQuestion & {
  type: typeof QUESTION_TYPES.RATING;
  lowLabel: string;
  highLabel: string;
};

export type FreeTextQuestion = BaseQuestion & {
  type: typeof QUESTION_TYPES.FREE_TEXT;
};

export type SurveyQuestion = RatingQuestion | FreeTextQuestion;

const VISIT_CONCLUDED_QUESTIONS = [
  {
    key: "csatRating",
    type: QUESTION_TYPES.RATING,
    text: "How was your experience with Curai today?",
    lowLabel: "Not at all satisfied",
    highLabel: "Extremely satisfied",
  },
  {
    key: "csatImprovement",
    type: QUESTION_TYPES.FREE_TEXT,
    text: "What could we have done better?",
    showIf: (answers) => {
      const rating = answers.csatRating;
      return typeof rating === "number" && rating <= 3;
    },
  },
] satisfies SurveyQuestion[];

export const CSAT_SURVEYS = {
  curai_visit_concluded: { questions: VISIT_CONCLUDED_QUESTIONS },
  async_rx_concluded: { questions: VISIT_CONCLUDED_QUESTIONS },
  async_dx_concluded: { questions: VISIT_CONCLUDED_QUESTIONS },
  rx_renewal_concluded: { questions: VISIT_CONCLUDED_QUESTIONS },
} as const satisfies Record<CSATFeature, { questions: SurveyQuestion[] }>;
